import styled from "styled-components";

export const StyledResult = styled.p`
    color: ${({ theme }) => theme.color.black};
    font-weight: 700;
    text-align: center;
    font-size: 25px;
    padding: 10px;
    display: flex;
    justify-content: center;
`
